import { useEffect, useState } from "react"
import AddIcon from "@mui/icons-material/Add"
import { Link } from "react-router-dom"
import CachedIcon from "@mui/icons-material/Cached"
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks"
import { useGlobalContext } from "../../../Context/GlobalContext"
import { saveAs } from "file-saver"
import jsPDF from "jspdf"
import ClipLoader from "react-spinners/ClipLoader"
import { Modal } from "react-responsive-modal"
import Select from "react-select"
import { IoMdArrowDropright } from "react-icons/io"
import BorderColorIcon from "@mui/icons-material/BorderColor"
import DeleteIcon from "@mui/icons-material/Delete"
import ProjectEditModal from "../../../components/Staff/Modals/ProjectEditModal"
import DeleteModal from "../../../../src/components/DeleteModal"
import "jspdf-autotable"
import Cookies from "js-cookie"
import { adjustTextColor } from "../../../utils/helper"

const Projects = () => {
  const [showAllTag, setShowAllTag] = useState(false)
  const [showAllMembers, setShowAllMembers] = useState(false)

  const [isLoading, setIsLoading] = useState(false)
  const [projectName, setProjectName] = useState("")
  const [open8, setOpen8] = useState(false)
  const [updateData, setUpdateData] = useState([])
  const onOpenModal8 = () => setOpen8(true)
  const [sortBy, setSortBy] = useState("status")
  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }
  const [isOpen, setIsOpen] = useState(true)

  const [isOpen15, setIsOpen15] = useState(false)

  const toggleModal15 = () => {
    setIsOpen15(!isOpen15)
  }
  const [open, setOpen] = useState(false)
  const onOpenModal = () => setOpen(true)
  const onCloseModal = () => setOpen(false)
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#F4F5F9",
      borderColor: "#E2E8F0",
      minHeight: "38px",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#E2E8F0",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "14px",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#4A5568",
      ":hover": {
        backgroundColor: "#CBD5E0",
        color: "#2D3748",
      },
    }),
  }

  const { baseUrl, openToast } = useGlobalContext()
  const [isTableOpen, setIsTableOpen] = useState(false)
  const [projectDetails, setProjectDetails] = useState([])
  const [departments, setDepartments] = useState([])
  const [exportFormat, setExportFormat] = useState("CSV")
  const [openProjectEditModal, setOpenProjectEditModal] = useState(false)
  const [deleteProject, setDeleteProject] = useState()
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [rowsToShow, setRowsToShow] = useState(25)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [isDownloading, setIsDownloading] = useState(false)
  const [status, setStatus] = useState([])
  const [priority, setPriority] = useState([])
  const [expandedItems, setExpandedItems] = useState({})
  const [selectedProjects, setSelectedProjects] = useState([])
  const [massDelete, setMassDelete] = useState(false)

  const fetchProjectStatus = async () => {
    setIsLoading(true)
    try {
      const result = await fetch(baseUrl + "project-status/", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      })
      const data = await result.json()
      if (result.status === 200) {
        setStatus(data.data)
      } else {
        openToast("Unable to fetch project status", "error")
      }
    } catch (error) {
      openToast("Error fetching project status", "error")
    } finally {
      setIsLoading(false)
    }
  }

  const fetchProjectPriority = async () => {
    setIsLoading(true)

    try {
      const result = await fetch(baseUrl + "project-Priority/", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      })
      const data = await result.json()
      if (result.status === 200) {
        setPriority(data.data)
      } else {
        openToast("Unable to fetch project priority", "error")
      }
    } catch (error) {
      openToast("Error fetching project priority", "error")
    } finally {
      setIsLoading(false)
    }
  }

  const handleSelectChange = (event) => {
    setRowsToShow(Number(event.target.value))
  }

  const fetchData = async () => {
    const result = await fetch(baseUrl + `project?page=${currentPage}&limit=${rowsToShow}`, {
      headers: {
        Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
      },
    })
    const data = await result.json()
    return data?.data
  }

  const handleExport = () => {
    if (exportFormat === "CSV") exportCSV()
    else if (exportFormat === "PDF") exportPDF()
    else if (exportFormat === "Print") printRoles()
  }

  const exportCSV = async () => {
    setIsDownloading(true)
    try {
      const headers = [
        "Project Name",
        "Customer",
        "Billing Type",
        "Status",
        "Total Rate",
        "Estimate Hours",
        "Members",
        "Tags",
        "Start Date",
        "Deadline",
        "Description",
      ]

      const d = await fetchData()
      console.log(d)

      const csvData = [
        headers.join(","), // Add headers
        ...d.map((project) => {
          const members = project?.staffId?.map((item) => item?.User?.name).join(";") // Convert members array to semicolon-separated string
          const tags = project?.tags?.join(";") // Convert tags array to semicolon-separated string

          return [
            project?.project_name,
            project?.customerDetails?.User?.name || "N/A", // Handle undefined `customer` gracefully
            project?.billing_type,
            project?.projectStatus?.project_name,
            project?.total_rate,
            project?.estimated_hours,
            members,
            tags,
            project?.start_date,
            project?.deadline,
            project?.description,
          ].join(",") // Join all values into a single CSV row
        }),
      ].join("\n") // Join rows with newlines

      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" })
      saveAs(blob, "ProjectDetail.csv")
    } catch (error) {
      openToast("An unexpected error occurred. Please try again.", "error")
    } finally {
      setIsDownloading(false)
    }
  }

  const exportPDF = async () => {
    setIsDownloading(true)
    try {
      const doc = new jsPDF()

      // Define table headers
      const headers = [
        [
          "Project Name",
          "Customer",
          "Billing Type",
          "Status",
          "Total Rate",
          "Estimate Hours",
          "Members",
          "Tags",
          "Start Date",
          "Deadline",
          "Description",
        ],
      ]

      const d = await fetchData()

      // Map projectDetails into rows
      const rows = d.map((project) => {
        const members = project?.staffId?.map((item) => item?.User?.name).join(", ") // Convert array of members to a comma-separated string
        const tags = project?.tags?.join(", ") // Convert tags array to a comma-separated string

        return [
          project?.project_name || "N/A",
          project?.customerDetails?.User?.name || "N/A", // Handle undefined gracefully
          project?.billing_type || "N/A",
          project?.projectStatus?.project_name || "N/A",
          project?.total_rate || "N/A",
          project?.estimated_hours || "N/A",
          members || "N/A",
          tags || "N/A",
          project?.start_date || "N/A",
          project?.deadline || "N/A",
          project?.description || "N/A",
        ]
      })

      // Add title
      doc.setFontSize(16)
      doc.text("Project Details", 14, 10)

      // Add the table
      doc.autoTable({
        head: headers,
        body: rows,
        startY: 20, // Start below the title
        styles: {
          fontSize: 8, // Adjust font size for table
        },
        headStyles: {
          fillColor: [22, 160, 133], // Light green header background
          textColor: [255, 255, 255], // White header text
        },
      })

      // Save the PDF
      doc.save("ProjectDetails.pdf")
    } catch (error) {
      openToast("An unexpected error occurred. Please try again.", "error")
    } finally {
      setIsDownloading(false)
    }
  }

  const printRoles = async () => {
    setIsDownloading(true)
    try {
      const d = await fetchData()

      const printContent = `
    <html>
      <head>
        <style>
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;
          }
          table, th, td {
            border: 1px solid #ccc;
          }
          th, td {
            padding: 10px;
            text-align: left;
          }
          th {
            background-color: #f4f4f4;
          }
          h1 {
            text-align: center;
          }
        </style>
      </head>
      <body>
        <h1>Project Details</h1>
        <table>
          <thead>
            <tr>
              <th>Project Name</th>
              <th>Customer</th>
              <th>Billing Type</th>
              <th>Status</th>
              <th>Total Rate</th>
              <th>Estimate Hours</th>
              <th>Members</th>
              <th>Tags</th>
              <th>Start Date</th>
              <th>Deadline</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            ${d
              .map((project) => {
                const members = project?.staffId?.map((item) => item?.User?.name).join(", ")
                const tags = project?.tags?.join(", ")
                return `
                <tr>
                  <td>${project?.project_name || "N/A"}</td>
                  <td>${project?.customerDetails?.User?.name || "N/A"}</td>
                  <td>${project?.billing_type || "N/A"}</td>
                  <td>${project?.projectStatus.project_name || "N/A"}</td>
                  <td>${project?.total_rate || "N/A"}</td>
                  <td>${project?.estimated_hours || "N/A"}</td>
                  <td>${members || "N/A"}</td>
                  <td>${tags || "N/A"}</td>
                  <td>${project?.start_date || "N/A"}</td>
                  <td>${project?.deadline || "N/A"}</td>
                  <td>${project?.description || "N/A"}</td>
                </tr>
              `
              })
              .join("")}
          </tbody>
        </table>
      </body>
    </html>
  `

      // Open a new window and trigger print
      const newWindow = window.open("", "_blank")
      newWindow.document.write(printContent)
      newWindow.document.close()
      newWindow.focus()
      newWindow.print()
      newWindow.close()
    } catch (error) {
      openToast("An unexpected error occurred. Please try again.", "error")
    } finally {
      setIsDownloading(false)
    }
  }

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1)
  }

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1)
  }

  async function fetchProjectDetails() {
    try {
      setIsLoading(true)
      const result = await fetch(baseUrl + `project?page=${currentPage}&limit=10`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      })
      if (result.status === 200) {
        const res = await result.json()
        setProjectDetails(res?.data)
        setTotalPages(res?.meta?.totalPages)
        setTotalRecords(res?.meta?.totalRecords)
        if (res.data && res.data.length > 0) {
          setIsTableOpen(true)
        }
      } else {
        const res = await result.json()
        console.log("an internal server error occured", res.message)
        setProjectDetails([])
      }
    } catch (error) {
      console.error("failed to fetch projects", error)
      setProjectDetails([])
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchProjectDetails()
    fetchProjectStatus()
    fetchProjectPriority()
  }, [])

  console.log(isLoading)

  // handle search projects
  const handleSearchProject = async () => {
    const queryParams = new URLSearchParams({
      project_name: projectName,
    }).toString()
    setIsLoading(true)
    try {
      const response = await fetch(`${baseUrl}project/search-projectByName?${queryParams}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      })
      console.log(response)
      if (response.ok) {
        const result = await response.json()
        console.log(result)
        setProjectDetails(result.data)
      } else {
        console.log("error while fetching project")
      }
    } catch (error) {
      console.error("Error searching project:", error)
    } finally {
      setIsLoading(false)
    }
  }

  const deleteProjectFunc = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(baseUrl + `project/${deleteProject}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      })
      if (response.status === 200) {
        openToast("Project deleted successfully", "success")
        onCloseModal()
        setPriority((prev) => prev.filter((item) => item.Project.some((project) => project.id !== deleteProject)))
        setStatus((prev) => prev.filter((item) => item.Project.some((project) => project.id !== deleteProject)))
        fetchProjectPriority()
        fetchProjectStatus()
        fetchProjectDetails()
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleMassDelete = () => {
    setMassDelete(!massDelete)
    if (!massDelete) {
      const allProjects = projectDetails.map((project) => ({
        value: project.id,
        label: project.project_name,
      }))
      setSelectedProjects(allProjects)
    } else {
      setSelectedProjects([])
    }
  }

  const handleSelectChangeBulk = (selectedOptions) => {
    setSelectedProjects(selectedOptions || [])
  }

  const deleteProjectsBulk = async () => {
    try {
      setIsLoading(true)
      const response = await fetch(`${baseUrl}project/bulk`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          projectIds: selectedProjects.map(({ value }) => value),
        }),
      })

      if (response.ok) {
        openToast("Projects deleted successfully")
        onCloseModal()
        fetchProjectStatus()
        fetchProjectDetails()
      }
    } catch (error) {
      console.error("Failed to delete projects:", error)
      openToast("Failed to delete projects", "error")
    } finally {
      setIsLoading(false)
    }
  }

  // Debounced search effect
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (projectName.trim()) {
        handleSearchProject()
      } else {
        fetchProjectDetails() // Fetch all projects if search input is cleared
      }
    }, 3000)

    return () => clearTimeout(delayDebounceFn) // Cleanup function to clear the timeout
  }, [projectName])

  const toggleItem = (id) => {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  return (
    <div className="bg-white px-4 py-6 w-full">
      <ProjectEditModal
        open={openProjectEditModal}
        setOpen={setOpenProjectEditModal}
        editProject={updateData}
        fetchProjects={fetchProjectDetails}
        fetchStatusProject={fetchProjectStatus}
        fetchPriorityProject={fetchProjectPriority}
      />
      <DeleteModal
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        onCloseModal={onCloseModal}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        callback={deleteProjectFunc}
      />

      <div className="mb-4">
        <Link to="/create-new-project" className="flex items-center gap-[4px] allcrm-btn px-4 py-2 w-[124px] text-sm">
          <AddIcon className="addicon-all" /> New Project
        </Link>
      </div>

      <div className="bg-white shadow-cs p-[20px] border rounded-lg">
        <h2 className="flex items-center gap-[6px] mb-[10px] font-medium">
          {" "}
          <LibraryBooksIcon />
          Projects
        </h2>
        <Modal open={open} onClose={onCloseModal} center>
          <div className="pb-[20px] border-[#dbdbdb] border-b">
            <h2>Bulk Actions</h2>
          </div>
          <div className="flex items-center gap-[8px] mt-[32px] mb-[30px]">
            <input type="checkbox" checked={massDelete} onChange={handleMassDelete} />
            <p className="text-[14px]">Mass Delete</p>
          </div>
          <div className="w-[100%]">
            <Select
              isMulti
              options={projectDetails.map((project) => ({
                value: project.id,
                label: project.project_name,
              }))}
              onChange={handleSelectChangeBulk}
              value={selectedProjects}
              className="basic-multi-select"
              classNamePrefix="select"
              styles={customStyles}
            />
          </div>
          {selectedProjects.length === 0 && (
            <p className="mt-[10px] text-[14px] text-[red]">
              If you do not select any projects, all projects will be deleted.
            </p>
          )}
          <div className="flex justify-end gap-[10px] mt-[24px] pr-[10px] pb-3">
            <button className="second-btn" onClick={deleteProjectsBulk} disabled={isLoading}>
              {isLoading ? "Deleting..." : "Delete"}
            </button>
          </div>
        </Modal>

        <div className="flex sm:flex-row flex-col justify-between items-center gap-2 mb-3">
          <div className="flex sm:flex-row flex-col flex-wrap items-center gap-2 w-full">
            <select
              onChange={handleSelectChange}
              className="shadow-sm p-[7px] border border-[#e5e7eb] rounded-md focus:outline-none w-full sm:w-[60px] text-[14px]"
            >
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="120">120</option>
            </select>
            <select
              onChange={(e) => setExportFormat(e.target.value)}
              className="shadow-sm p-[7px] border border-[#e5e7eb] rounded-md focus:outline-none w-full sm:w-[67px] text-[14px]"
            >
              <option value="CSV">CSV</option>
              <option value="PDF">PDF</option>
              <option value="Print">Print</option>
            </select>

            <button
              onClick={handleExport}
              disabled={isDownloading}
              className="bg-[#27004a] p-[7px] rounded-md w-full sm:w-[123px] text-[14px] text-white cursor-pointer"
            >
              {isDownloading ? "Exporting File..." : "Export File"}
            </button>
            <button
              className="shadow-sm p-[7px] border border-[#e5e7eb] rounded-lg w-full sm:w-[123px] text-[14px]"
              onClick={onOpenModal}
            >
              Bulk Action <CachedIcon className="newsidebar-icon" />{" "}
            </button>
          </div>
          <div className="relative flex flex-wrap justify-end items-center gap-2 w-full">
            <label htmlFor="">Sort by:</label>
            <select
              onChange={(e) => setSortBy(e.target.value)}
              className="shadow-sm p-[7px] border border-[#e5e7eb] rounded-md focus:outline-none text-[14px]"
            >
              <option value="status">Project Status</option>
              <option value="priority">Project Priority</option>
            </select>
            {/* <input
              type="text"
              placeholder="Search"
              onChange={(e) => setProjectName(e.target.value)}
              className="p-[10px] pr-7 border border-1 rounded-3xl focus:outline-none w-[100%] md:w-[200px] h-[38px] text-[#000] text-[15px] ]"
            />
            <SearchIcon className="right-[10px] absolute search-icon font-thin text-[#000] text-[#dddddd; ]" />{" "} */}
          </div>
        </div>
        {isLoading && (
          <div className="flex justify-center items-center py-12 w-full">
            <tr className="h-[100px]">
              <td
                colSpan="9"
                className="py-4 border-[#dbdbdb] font-semibold text-gray-600 text-xl text-center whitespace-nowrap"
              >
                <ClipLoader color="#27004a" size={40} />
              </td>
            </tr>
          </div>
        )}
        {!isLoading && sortBy === "status" && status?.length === 0 && (
          <div className="flex justify-center items-center py-12 w-full">
            <tr className="h-[100px]">
              <td
                colSpan="13"
                className="py-4 border-[#dbdbdb] font-semibold text-md text-red-600 text-center whitespace-nowrap"
              >
                No Project Found
              </td>
            </tr>
          </div>
        )}
        {!isLoading && sortBy !== "status" && priority?.length === 0 && (
          <div className="flex justify-center items-center py-12 w-full">
            <tr className="h-[100px]">
              <td
                colSpan="13"
                className="py-4 border-[#dbdbdb] font-semibold text-md text-red-600 text-center whitespace-nowrap"
              >
                No Project Found
              </td>
            </tr>
          </div>
        )}

        {!isLoading && (
          <div className="bg-white w-full">
            {(sortBy === "status" ? status : priority).map((item) => (
              <div key={item.id} className="mb-2 last:mb-0 border border-gray-200 rounded-lg w-full">
                <div
                  className="flex justify-between items-center hover:bg-gray-50 p-3 w-full cursor-pointer"
                  onClick={() => toggleItem(item.id)}
                >
                  <div className="flex items-center hover:bg-gray-50 cursor-pointer">
                    <IoMdArrowDropright
                      className={`text-xl transition-transform duration-200 ${
                        expandedItems[item.id] ? "rotate-90" : ""
                      }`}
                    />
                    <span
                      className={`ml-2 font-medium text-sm px-2 py-1 rounded-md`}
                      style={{
                        color: adjustTextColor(item.project_color || item.Priority_color),
                        backgroundColor: item.project_color || item.Priority_color || "#27004a",
                      }}
                    >
                      {item.project_name || item.Priority_name}
                    </span>
                  </div>
                  <span className="flex justify-center items-center ml-2 text-sm">
                    {
                      projectDetails.filter((project) =>
                        sortBy === "status" ? project.status === item.id : project.priority === item.id,
                      ).length
                    }{" "}
                    Project
                  </span>
                </div>

                {expandedItems[item.id] && (
                  <div className="custom-scrollbar-x border-gray-200 border-t overflow-x-scroll">
                    <table className="border border-[#dcdbdb] rounded-lg w-full overflow-hidden border-collapse table-auto">
                      <thead className="shadow-md border border-gray-300">
                        <tr>
                          <th className="p-2 border-r font-medium text-xs text-center whitespace-nowrap">#</th>
                          <th className="p-2 border-r font-medium text-xs text-center whitespace-nowrap">
                            Project Name
                          </th>
                          <th className="p-2 border-r font-medium text-xs text-center whitespace-nowrap">Customer</th>
                          <th className="p-2 border-r font-medium text-xs text-center whitespace-nowrap">Progress</th>
                          <th className="p-2 border-r font-medium text-xs text-center whitespace-nowrap">
                            Billing Type
                          </th>
                          <th className="p-2 border-r font-medium text-xs text-center whitespace-nowrap">Total Rate</th>
                          <th className="p-2 border-r font-medium text-xs text-center whitespace-nowrap">
                            Estimated Hours
                          </th>
                          <th className="p-2 border-r font-medium text-xs text-center whitespace-nowrap">Members</th>
                          <th className="p-2 border-r font-medium text-xs text-center whitespace-nowrap">Tags</th>
                          <th className="p-2 border-r font-medium text-xs text-center whitespace-nowrap">Start Date</th>
                          <th className="p-2 border-r font-medium text-xs text-center whitespace-nowrap">Deadline</th>
                          <th className="p-2 border-r font-medium text-xs text-center whitespace-nowrap">
                            Description
                          </th>
                          <th className="p-2 border-r font-medium text-xs text-center whitespace-nowrap">Action</th>
                        </tr>
                      </thead>
                      <tbody className="">
                        {item.Project.length > 0 ? (
                          item.Project.map((project, index) => (
                            <tr key={project.id} className="hover:bg-gray-50 border-b">
                              <td className="p-2 border-[rgb(219,219,219)] border-r text-[12px] text-center whitespace-nowrap">
                                {index + 1}
                              </td>
                              <td className="p-2 border-[#dbdbdb] border-r text-[12px] text-center whitespace-nowrap">
                                <Link to="#" className="text-[#27004a]">
                                  {project?.project_name}
                                </Link>
                              </td>
                              <td className="p-2 border-[#dbdbdb] border-r text-[12px] text-center whitespace-nowrap">
                                {project?.customerDetails?.user?.name || "N/A"}
                              </td>
                              <td className="p-2 border-[#dbdbdb] border-r text-[12px] text-center whitespace-nowrap">
                                0%
                              </td>
                              <td className="p-2 border-[#dbdbdb] border-r text-[12px] text-center whitespace-nowrap">
                                {project?.billing_type}
                              </td>

                              <td className="p-2 border-[#dbdbdb] border-r text-[12px] text-center whitespace-nowrap">
                                {project?.total_rate}
                              </td>
                              <td className="p-2 border-[#dbdbdb] border-r text-[12px] text-center whitespace-nowrap">
                                {project?.estimated_hours}
                              </td>
                              <td className="p-2 border-[#dbdbdb] border-r text-[12px] text-center whitespace-nowrap">
                                <div className="flex flex-col gap-1">
                                  {(() => {
                                    const groupedStaff = []
                                    for (let i = 0; i < project?.staffId?.length; i += 3) {
                                      groupedStaff.push(project?.staffId?.slice(i, i + 3))
                                    }
                                    return (
                                      <>
                                        {groupedStaff
                                          ?.slice(0, showAllMembers ? groupedStaff.length : 1)
                                          ?.map((group, groupIndex) => (
                                            <div key={groupIndex} className="flex justify-center space-x-2">
                                              {group.map((item, i) => (
                                                <span key={i} className="mr-2 p-1 border rounded-md text-[12px]">
                                                  {item?.User?.name}
                                                </span>
                                              ))}
                                            </div>
                                          ))}
                                      </>
                                    )
                                  })()}
                                  {project?.staffId?.length > 3 && (
                                    <button
                                      onClick={() => setShowAllMembers(!showAllMembers)}
                                      className="font-bold text-[#27004a] text-2xl"
                                    >
                                      ...
                                    </button>
                                  )}
                                </div>
                              </td>
                              <td className="p-2 border-[#dbdbdb] border-r text-[12px] text-center whitespace-nowrap">
                                <div className="flex flex-col gap-1">
                                  {(() => {
                                    const groupedTags = []
                                    for (let i = 0; i < project?.tags?.length; i += 3) {
                                      groupedTags.push(project.tags.slice(i, i + 3))
                                    }

                                    // const tagstoShow = showAllTag ? project?.tags : project?.tags?.slice(0, 3);
                                    return (
                                      <>
                                        {groupedTags
                                          ?.slice(0, showAllTag ? groupedTags.length : 1)
                                          .map((group, groupIndex) => (
                                            <div key={groupIndex} className="flex justify-center space-x-2">
                                              {group.map((tag, i) => (
                                                <span key={i} className="mr-2 p-1 border rounded-md text-[12px]">
                                                  {tag}
                                                </span>
                                              ))}
                                            </div>
                                          ))}
                                      </>
                                    )
                                  })()}
                                  {project?.tags?.length > 3 && (
                                    <button
                                      onClick={() => setShowAllTag(!showAllTag)}
                                      className="font-bold text-[#27004a] text-2xl"
                                    >
                                      ...
                                    </button>
                                  )}
                                </div>
                              </td>
                              <td className="p-2 border-[#dbdbdb] border-r text-[12px] text-center whitespace-nowrap">
                                {project?.start_date}
                              </td>
                              <td className="p-2 border-[#dbdbdb] border-r text-[12px] text-center whitespace-nowrap">
                                {project?.deadline}
                              </td>
                              <td className="border-[#dbdbdb]p-2 border-r max-w-[200px] overflow-hidden text-[12px] text-center truncate whitespace-nowrap">
                                {project?.description}
                              </td>
                              <td className="flex justify-center items-center gap-2 p-2">
                                <BorderColorIcon
                                  className="text-[#27004a] cursor-pointer"
                                  // onClick={() => setSelectedClient(item)}
                                  onClick={() => {
                                    setOpenProjectEditModal(true)
                                    setUpdateData(project)
                                  }}
                                />
                                <button
                                  onClick={() => {
                                    onOpenModal8()
                                    setDeleteProject(project?.id)
                                    setOpenDeleteModal(true)
                                  }}
                                >
                                  <DeleteIcon className="text-red-500 cursor-pointer" />
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr className="h-[100px]">
                            <td colSpan="13" className="py-4 font-semibold text-red-500 text-sm text-center">
                              No projects found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-[14px] pb-[0] w-[100%]">
          <p className="text-[#a5a1a1] text-[14px]">Total Records : {totalRecords}</p>
          <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md pagination">
            <button
              onClick={handlePrevious}
              disabled={currentPage === 1}
              className={`pt-2 pb-[8px] text-[12px] ${currentPage == 1 ? "opacity-40" : ""}`}
            >
              Previous
            </button>
            <span className="flex items-center bg-[#27004a] pr-3 pl-3 text-[12px] text-white">{currentPage}</span>
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className={`pt-2 pb-[8px] text-[12px] ${currentPage === totalPages ? "opacity-40" : ""}`}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Projects

